<template>
  <div v-if="pageDetector.isSearchComponentsPage">
    <SearchFloatingSearchButton
      v-if="showFloatingSearchButton"
      class="floating-search-button"
      :class="{ 'floating-search-button--down': !shouldShowFooterTab }"
    />
    <Transition name="tab">
      <FooterTab v-if="shouldShowFooterTab" />
    </Transition>
  </div>
  <div v-else>
    <CommonToTop v-if="showToTop" />
    <FooterTab v-if="showFooterTab" />
  </div>
</template>

<script setup lang="ts">
import { ScrollDirection } from '@/composables/useScrollDirection'
import PageDetector from '@/utils/PageDetector'
import { useMainStore } from '@/store'

const store = useMainStore()

const hideFooterFromScrolling = ref(false)
const { direction: scrollDirection } = useScrollDirection()

const route = useRoute()
const pageDetector = computed(() => new PageDetector(route))

const canDisplayFooterTab = computed(() => {
  if (store.$state.native_app) return false
  if (pageDetector.value.isEventListPage || pageDetector.value.isTopPage) return true
  if (pageDetector.value.isGenderOrCompleteParticipantPage || pageDetector.value.isParticipantsListPage) return true
  if (pageDetector.value.isMarriagesPage) return true
  if (pageDetector.value.isClEventsPage) return true
  if (pageDetector.value.isMessagesPage) return true
  return false
})

const showFooterTab = computed<boolean>(() => Boolean(store.isSP) && canDisplayFooterTab.value)
const showToTop = computed(() => !store.event_search_modal)
const shouldShowFooterTab = computed(() => showFooterTab.value && !hideFooterFromScrolling.value)
const showFloatingSearchButton = computed(
  () => pageDetector.value.isSearchComponentsPage && store.isSP && !store.event_search_modal
)

watch(scrollDirection, value => {
  switch (value) {
    case ScrollDirection.Down:
      hideFooterFromScrolling.value = true
      break
    case ScrollDirection.Up:
      hideFooterFromScrolling.value = false
      break
  }
})
</script>

<style lang="scss" scoped>
.tab-enter-active,
.tab-leave-active {
  transition: transform 0.8s;
}

.tab-enter-from,
.tab-leave-to {
  transform: translateY(100%);
}

.to-top-button--down {
  transform: translateY(calc(7rem - 1.2rem));
}

.to-top-button {
  transition: transform 0.8s;
}

.floating-search-button {
  bottom: 7rem;
  right: 1.6rem;
  transition: transform 0.8s;
}

.floating-search-button--down {
  transform: translateY(calc(7rem - 1.6rem));
}
</style>
